module.exports = __webpack_public_path__ + "img/uploadFile.1b106574.png";